import React from "react";
import { StyleSheet } from "react-native";
import { Text, View } from "@components/atoms/Themed";
import Spacer from "@components/atoms/Spacer";
import ResponsiveImage from "@components/atoms/ResponsiveImage";
import Fonts from "@constants/Fonts";
import useExecptionalError from "@hooks/useExecptionalError";
import { squareIcon } from "@components/atoms/AssetImage";
import BackHome from "@components/organisms/Fallback/FallbackBackHome";

export default function FallbackMaintenance() {
  const { state: globalError } = useExecptionalError();

  return (
    <>
      <Spacer height={24} />

      <View style={styles.center}>
        <View style={styles.squareIcon}>
          <ResponsiveImage height={148} source={squareIcon} width={595} />
        </View>
      </View>

      <Spacer height={50} />
      <Text style={styles.caption}>
        {globalError?.message ??
          "現在バージョンアップのため、メンテナンス中です。サービス再開まで少々お待ち下さい"}
      </Text>
      <Spacer height={30} />
      <BackHome />
    </>
  );
}

const styles = StyleSheet.create({
  center: {
    alignItems: "center",
    justifyContent: "center",
  },
  caption: {
    ...Fonts.lr130,
    paddingHorizontal: 16,
  },
  squareIcon: {
    width: "100%",
    maxWidth: 390,
    height: 58,
  },
});
